import {
    Accordion, AccordionSummary, Avatar, Typography, AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './AccordionSetup.scss';

/**
 * @param {{
 *  id: string;
 *  stepIndex: string;
 *  summary: string;
 *  headerTitle: string;
 *  children: any;
 *  className?: string;
 * }} param0
 */
const AccordionSetup = ({
    id,
    stepIndex,
    summary,
    headerTitle,
    children,
    className,
}) => (
    <Accordion
        id={id}
        className={`core--accordion-setup ${className || ''}`}
        defaultExpanded
    >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="accordion-setup--header-main">
                <Avatar className="accordion-setup--header-avatar">{stepIndex}</Avatar>
                <Typography variant="h6">{headerTitle}</Typography>
            </div>
            <Typography className="accordion-setup--header-summary">{summary}</Typography>
        </AccordionSummary>
        <AccordionDetails>
            {children}
        </AccordionDetails>
    </Accordion>
);
export default AccordionSetup;
